export enum Choice {
  yes = "Yes",
  no = "No",
}
